<div class="row" id="selectTaxonomyRowHeader">
  <div class="col-12">
    <button class="btn btn-clear btn-back pl-0 d-flex align-items-center"
      (click)="backToTaxonomyList();removeOptionsToCopySaved();" *ngIf="currentTab === 'browse taxonomy'">
      <em class="material-icons-outlined font-4x" aria-hidden="true">arrow_back_ios</em>
      <span class="text-underline">All Taxonomy</span>
    </button>

    <button class="btn btn-clear btn-back pl-0 d-flex align-items-center"
      *ngIf="currentTab === 'search taxonomy' && showBackToSearch" (click)="navigateToSearchResults();">
      <em class="material-icons-outlined font-4x" aria-hidden="true">arrow_back_ios</em>
      <span class="text-underline">{{searchResultLength}} Results</span>
    </button>

    <div class="form-row mb-3 mt-1">

      <div class="col-2 pl-0">
        <form [formGroup]="form">
          <label class="sr-only" for="{{viewLocation}}_associationType">Select file type</label>
          <div class="form-group mb-0">
            <select class="custom-select p-1" required id="{{viewLocation}}_associationType"
              [(ngModel)]="selectedAssociationType" (ngModelChange)="onTypeSelected()"
              formControlName="formAssociationType" aria-labelledby="associationTypeLabel associationTypeHelp">
              <option [ngValue]="null">Select Association Type</option>
              <option *ngFor="let item of associationTypes" [ngValue]="item">{{ item.display_name }}</option>
            </select>
          </div>
        </form>
      </div>

      <div class="col-10" *ngIf="selectedAssociationType && selectedAssociationType.type_name === 'isParentOf'">
        <div class="d-inline bg-lighter px-3 py-2">
          <p class="d-inline mb-0">You can also append these node/s to the selected taxonomy</p>
          <button class="btn btn-clear text-underline" data-toggle="modal" data-target="#associationSettings"
            (click)="requiredFullHierarchyFlag = 0;onTypeSelected();selectOptions();">Append<span class="sr-only">Opens
              in a new dialog</span></button>
          <span class="px-2">or</span>
          <button class="btn btn-clear text-underline" data-toggle="modal" data-target="#associationSettings"
            (click)="requiredFullHierarchyFlag = 1;onTypeSelected();selectOptions();">Append
            with child nodes<span class="sr-only">Opens in a new dialog</span></button>
        </div>
      </div>

    </div>

    <!-- Save association settings -->
    <div class="mb-3 mt-1 save-association-setting" *ngIf="optionsToCopySaved">
      <div class="row justify-content-between align-items-center">
        <div class="col-lg-10">
          <div class="d-flex justify-content-start">
            <div class="pr-5 mr-5">
              <p class="mb-0"><span class="font-bold">Association Type: </span>Is parent of</p>
            </div>
            <div class="pr-5 mr-5">
              <p class="mb-0 font-bold">
                <!-- {{ requiredFullHierarchyFlag && requiredFullHierarchyFlag === 0 ? 'Append' : 'Append with child nodes'}} -->
                {{displayOption}}
              </p>
            </div>
            <div class="pr-5">
              <p class="mb-0 d-inline"><span class="font-bold">
                  {{displayText}}
                  <!-- {{isCopy && !isCopyAssociation && saveButtonClickedForCopy
                    ? 'Settings: Exact Match with Original':''}} {{!isCopy && isCopyAssociation && saveButtonClickedForCopy?
                    'Settings: Association copied':''}} {{isCopy && isCopyAssociation && saveButtonClickedForCopy? 'Settings:
                    Association copied & Exact Match with Original':''}} -->
                </span>
              </p>
            </div>
          </div>
        </div>
        <div>
          <button type="button" class="btn btn-icon cursor-pointer px-2 py-0" aria-label="Association Settings"
            data-toggle="modal" data-target="#associationSettings" (click)="onTypeSelected();selectOptions();"><em
              class="material-icons-outlined font-4x" aria-hidden="true">settings</em></button>
          <button class="btn btn-clear text-underline" id="removeAppendChild"
            (click)="removeOptionsToCopySaved();">Remove</button>
        </div>
      </div>
    </div>
    <!-- Save association settings -->

  </div>
</div>
